import React from 'react';
import Arrow from '../components/Arrow';
import CustomDropDownIcon from '../assets/CustomDropDownIcon';

const ExpandButton = () => (
  <button className="no-style-button" type="button">
    <CustomDropDownIcon fill={'#DEE4F3'} width={'17px'} height={'25px'}/>
  </button>
);

export default ExpandButton;



// WEBPACK FOOTER //
// ./src/components/ExpandButton.jsx